export default {
  addSelectedDateAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addSelectedDate", payload)
      resolve()
    })
  }
}
